<template>
  <v-container
    fluid
    @contextmenu="show"
    :style="{ 'background-color': widget.background_color }"
  >
    <InfoAlert
      :showDismissibleAlert="showDismissibleAlert"
      v-on:close="showDismissibleAlert = false"
      :info="info"
    />
    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      @click="dialog = true"
      v-if="$store.state.settingMode && edit"
    >
      <v-list
        :dark="$store.getters.getColorPalette().isDark"
        :color="$store.getters.getColorPalette().backgroundColorCode"
      >
        <v-list-item @click="update = true">
          <v-list-item-title
            ><strong>{{
              $store.getters.getTextMap().edit
            }}</strong></v-list-item-title
          >
          <v-list-item-icon>
            <v-icon small>mdi-pencil</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item @click="deleteWidget">
          <v-list-item-title
            ><strong
              >{{ $store.getters.getTextMap().delete }}
            </strong></v-list-item-title
          >
          <v-list-item-icon>
            <v-icon color="red" small>mdi-trash-can</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog
      v-model="update"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card
        :dark="$store.getters.getColorPalette().isDark"
        :color="$store.getters.getColorPalette().backgroundColorCode"
      >
        <v-toolbar
          :dark="$store.getters.getColorPalette().isDark"
          :color="$store.getters.getColorPalette().foregroundColorCode"
        >
          <v-btn
            icon
            :dark="$store.getters.getColorPalette().isDark"
            @click="update = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ widget.label }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              :dark="$store.getters.getColorPalette().isDark"
              text
              @click="update = false"
              >{{ $store.getters.getTextMap().close }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <AddParamGroupBarWidget
          :widget="widget"
          :disableTimeframe="disableTimeframe"
          :idealValue="idealValue"
          :idealLabel="idealLabel"
          v-on:close="update = false"
          v-on:success="$emit('update')"
        />
      </v-card>
    </v-dialog>
    <v-skeleton-loader
      v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
    <v-row v-if="widget.meta.data" no-gutters>
      <v-col
        :style="{ color: $store.getters.getColorPalette().accentCode }"
        align-self="center"
        v-if="showTotal"
      >
        <strong>
          Total:
          <span>
            {{ Math.round(total * 100) / 100 }}
          </span>
        </strong>
      </v-col>
      <v-col
        :style="{ color: $store.getters.getColorPalette().accentCode }"
        align-self="center"
        v-if="showAvg"
      >
        <strong>
          Average:
          <span>
            {{ Math.round(avg * 100) / 100 }}
          </span>
        </strong>
      </v-col>
      <v-col align="right">
        <v-btn-toggle
          :dark="$store.getters.getColorPalette().isDark"
          v-model="graphType"
          mandatory
          rounded
        >
          <v-btn small>{{ $store.getters.getTextMap().bar }} </v-btn>
          <v-btn small>{{ $store.getters.getTextMap().line }}</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <div
      v-if="widget.meta && widget.meta.data"
      ref="vis"
      :style="[
        widget.height === 'fixed'
          ? {
              'background-color': widget.background_color
                ? widget.background_color
                : $store.getters.getColorPalette().background2ColorCode,
              height: '150px',
            }
          : {},
      ]"
    ></div>
    <div
      v-else
      :style="[
        widget.height === 'fixed'
          ? { height: '175px', 'text-align': 'center' }
          : { 'text-align': 'center' },
      ]"
    >
      <v-icon small>mdi-hail</v-icon>
      <h5>{{ $store.getters.getTextMap().not_configured }}</h5>
    </div>
  </v-container>
</template>
<script>
import Plotly from "plotly.js";
import moment from "moment";
import InfoAlert from "@/components/InfoAlert";
import AddParamGroupBarWidget from "@/components/crud_components/widgets/AddParamGroupBarWidget";
import axios from "axios";

export default {
  name: "ParamGroupBarWidget",
  components: {
    AddParamGroupBarWidget,
    InfoAlert,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
    timeframe: {
      type: String,
    },
    edit: {
      type: Boolean,
      required: true,
    },
    disableTimeframe: {
      type: Boolean,
      required: true,
    },
    idealValue: Number,
    idealLabel: String,
  },
  data() {
    return {
      showDialog: false,
      x: 0,
      y: 0,
      showMenu: false,
      loading: false,
      info: "",
      showDismissibleAlert: false,
      update: false,
      total: 0,
      avg: 0,
      graphDataTemp: [],
      tempDataFinale: [],
      multiParamUsage: 0,
      getDataFlag: false,
      graphData: {},
      multiParamGraphData: {},
      inputData: [],
      benchmarkLine: {},
      graphType: "bar",
      multiPgraphType: "bar",
      barMode: "stack",
      layout: {
        barmode: "stack",
        font: { color: this.$store.getters.getColorPalette().accentCode },
        plot_bgcolor: this.widget.background_color
          ? this.widget.background_color
          : this.$store.getters.getColorPalette().background2ColorCode,
        paper_bgcolor: this.widget.background_color
          ? this.widget.background_color
          : this.$store.getters.getColorPalette().background2ColorCode,
        autosize: true,
        hoverlabel: { namelength: -1 },
        xaxis: {
          tickangle: -20,
          zeroline: false,
          showgrid: true,
          showticklabels: true,
          color: this.$store.getters.getColorPalette().accentCode,
        },
        yaxis: {
          range: [0, this.benchmarkYValue + 100],
          showticklabels: true,
          color: this.$store.getters.getColorPalette().accentCode,
        },
        uniformtext: {
          mode: "hide",
          minsize: 1,
        },
      },
    };
  },
  mounted() {
    if (
      this.widget &&
      this.widget.widget_id &&
      this.widget.meta &&
      this.widget.meta.data.length > 0
    ) {
      this.createInputData();
    }
  },
  computed: {
    showTotal() {
      let status = false;
      if (this.widget && this.widget.meta && this.widget.meta.showTotal) {
        status = true;
      }

      return status;
    },
    showAvg() {
      let status = false;
      if (this.widget && this.widget.meta && this.widget.meta.showAvg) {
        status = true;
      }

      return status;
    },
  },
  methods: {
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      if (this.$store.state.settingMode) {
        this.$nextTick(() => {
          this.showMenu = true;
        });
      }
    },
    createInputData() {
      let temp = [];
      //   console.log(this.$store.state.childOrgs, "this.$store.state.childOrg");
      for (let i of this.widget.meta.data) {
        temp.push({
          id: i.param,
          label: i.label,
          child_org_id: i.child_org_id,
          jwt: this.$store.state.childOrgs[i.child_org_id],
        });
      }
      this.inputData = temp;
    },
    init() {
      this.getData();
    },
    getFromDate(date_format) {
      let from_date = moment();
      if (this.timeframe && this.disableTimeframe) {
        if (this.timeframe !== "rtd") {
          switch (this.timeframe) {
            case "7":
              from_date = date_format
                ? moment().subtract(7, "days").format(date_format)
                : moment().subtract(7, "days");
              break;
            case "30":
              from_date = date_format
                ? moment().subtract(30, "days").format(date_format)
                : moment().subtract(30, "days");
              break;
            case "60":
              from_date = date_format
                ? moment().subtract(60, "days").format(date_format)
                : moment().subtract(60, "days");
              break;
            case "90":
              from_date = date_format
                ? moment().subtract(90, "days").format(date_format)
                : moment().subtract(90, "days");
              break;
            case "180":
              from_date = date_format
                ? moment().subtract(180, "days").format(date_format)
                : moment().subtract(180, "days");
              break;
            case "365":
              from_date = date_format
                ? moment().subtract(365, "days").format(date_format)
                : moment().subtract(365, "days");
              break;
            case "yesterday":
              from_date = date_format
                ? moment().subtract(1, "days").format(date_format)
                : moment().subtract(1, "days");
              break;
            case "ytd":
              from_date = date_format
                ? moment().startOf("year").format(date_format)
                : moment().startOf("year");
              break;
            default:
              from_date = date_format
                ? moment()
                    .subtract(1, "days")
                    .startOf("month")
                    .format(date_format)
                : moment().startOf("month");
              break;
          }
        } else {
          return from_date;
        }
      } else {
        if (
          this.widget &&
          this.widget.widget_id &&
          this.widget.meta &&
          this.widget.meta.time_frame
        ) {
          if (this.widget.meta.time_frame !== "rtd") {
            switch (this.widget.meta.time_frame) {
              case "7":
                from_date = date_format
                  ? moment().subtract(7, "days").format(date_format)
                  : moment().subtract(7, "days");
                break;
              case "30":
                from_date = date_format
                  ? moment().subtract(30, "days").format(date_format)
                  : moment().subtract(30, "days");
                break;
              case "60":
                from_date = date_format
                  ? moment().subtract(60, "days").format(date_format)
                  : moment().subtract(60, "days");
                break;
              case "90":
                from_date = date_format
                  ? moment().subtract(90, "days").format(date_format)
                  : moment().subtract(90, "days");
                break;
              case "180":
                from_date = date_format
                  ? moment().subtract(180, "days").format(date_format)
                  : moment().subtract(180, "days");
                break;
              case "365":
                from_date = date_format
                  ? moment().subtract(365, "days").format(date_format)
                  : moment().subtract(365, "days");
                break;
              case "yesterday":
                from_date = date_format
                  ? moment().subtract(1, "days").format(date_format)
                  : moment().subtract(1, "days");
                break;
              case "ytd":
                from_date = date_format
                  ? moment().startOf("year").format(date_format)
                  : moment().startOf("year");
                break;
              default:
                from_date = date_format
                  ? moment()
                      .subtract(1, "days")
                      .startOf("month")
                      .format(date_format)
                  : moment().startOf("month");
                break;
            }
          } else {
            return from_date;
          }
        }
      }
      return from_date;
    },
    addIdealValueToGraph() {
      this.layout["title"] = this.widget.label;
      if (this.widget.meta && this.widget.meta.legend) {
        this.layout["showlegend"] = true;
      }
      if (this.widget.meta && this.widget.meta.barmode) {
        this.layout["barmode"] = this.widget.meta.barmode;
      } else {
        this.layout["barmode"] = "group";
      }
      let type = this.graphType == 1 ? "line" : "bar";
      for (let i in this.graphData) {
        this.graphData[i]["type"] = type;
      }
      if (this.widget.meta.showIdeal) {
        let from_date;
        if (this.timeframe && this.disableTimeframe) {
          switch (this.timeframe) {
            case "7":
              from_date = moment().subtract(7, "days");
              break;

            case "30":
              from_date = moment().subtract(30, "days");
              break;

            case "60":
              from_date = moment().subtract(60, "days");
              break;

            case "90":
              from_date = moment().subtract(90, "days");
              break;

            case "180":
              from_date = moment().subtract(180, "days");
              break;

            case "365":
              from_date = moment().subtract(365, "days");
              break;

            case "yesterday":
              from_date = moment().subtract(1, "days");
              break;
            case "ytd":
              from_date = moment().startOf("year");
              break;

            default:
              from_date = moment().subtract(1, "days").startOf("month");
              break;
          }
        } else {
          switch (this.widget.meta.time_frame) {
            case "ytd":
              from_date = moment().startOf("year");
              break;
            case "mtd":
              from_date = moment().subtract(1, "days").startOf("month");
              break;
            case "yesterday":
              from_date = moment().subtract(1, "days");
              break;
            case "rtd":
              from_date = moment().startOf("day");
              break;
            default:
              from_date = moment().subtract(
                parseInt(this.widget.meta.time_frame),
                "days"
              );
          }
        }
        this.graphData["benchmarkLine"] = {
          type: "line",
          x: [
            from_date.format("YYYY-MM-DD HH:mm:ss"),
            moment().format("YYYY-MM-DD HH:mm:ss"),
          ],
          y: [
            this.widget.meta.idealValue ? this.widget.meta.idealValue : 0,
            this.widget.meta.idealValue ? this.widget.meta.idealValue : 0,
          ],
          line: {
            color: "red",
            width: 2,
            dash: "dash",
          },
          showlegend: true,
          name: this.widget.meta.idealLabel ? this.widget.meta.idealLabel : "",
        };
      }
      for (let k of Object.keys(this.multiParamGraphData)) {
        this.graphData[k] = this.multiParamGraphData[k];
      }
      Plotly.newPlot(
        this.$refs.vis,
        Object.values(this.graphData),
        this.layout,
        { displaylogo: false }
      );
    },
    multiParamsinit() {
      if (
        this.widget &&
        this.widget.meta &&
        this.widget.meta.data &&
        this.widget.meta.time_frame != "rtd" &&
        this.inputData
      ) {
        let type = this.graphType == 1 ? "line" : "bar";
        this.multiParamGraphData = {};
        for (let i of this.inputData) {
          this.multiParamGraphData[i.label] = {
            x: [],
            y: [],
            name: i.label,
            type: type,
            opacity: 0.9,
            showlegend: true,
            marker: {
              line: {
                color: this.$store.getters.getColorPalette().accentCode,
                width: 0.3,
              },
            },
          };
        }
      } else {
        this.addIdealValueToGraph();
      }
    },
    createMultipleParamChart() {
      this.multiParamsinit();
      if (this.widget && this.widget.meta) {
        this.total = 0;
        this.avg = 0;
        // let count = 0;
        this.layout.yaxis["title"] = this.widget.meta.yaxis_label;
        for (let i of this.tempDataFinale) {
          if (!(i.param in this.multiParamGraphData)) {
            let type = this.graphType == 1 ? "line" : "bar";
            this.multiParamGraphData[i.param] = {
              x: [],
              y: [],
              name: i.label,
              type: type,
              opacity: 0.9,
              marker: {
                line: {
                  color: this.$store.getters.getColorPalette().accentCode,
                  width: 1,
                },
              },
            };
          }
          for (let j of i.data) {
            this.multiParamGraphData[i.param]["x"].push(
              moment(Number(j.date), "YYYYMMDD").format("YYYY-MM-DD")
            );
            this.multiParamGraphData[i.param]["y"].push(j.usage);
            this.total += Number(j.usage);
            // count++;
          }
        }
        this.addIdealValueToGraph();
      }
    },
    async getData() {
      if (this.getDataFlag) {
        return;
      }
      this.getDataFlag = true;
      try {
        if (this.widget.meta.graphType) {
          this.graphType = this.widget.meta.graphType;
        }
        if (this.widget.height === "fixed") {
          this.layout.height = 160;
          this.layout.font = {
            size: 8,
            color: this.$store.getters.getColorPalette().accentCode,
          };
          this.layout.margin = { t: 40, b: 40, l: 40, r: 40 };
        }
        this.layout.colorway =
          this.$store.getters.getColorPalette().colorTypesCodeArray;
        this.graphData = {};
        this.multiParamGraphData = {};
        let from_date = moment().subtract(1, "days");
        if (this.widget.meta && this.widget.meta.time_frame != "rtd") {
          from_date = this.getFromDate("YYYYMMDD");
          let to_date = moment().format("YYYYMMDD");
          if (
            this.widget &&
            this.widget.meta &&
            this.widget.meta.data &&
            this.inputData &&
            this.inputData.length > 0
          ) {
            this.tempDataFinale = [];
            for (let i of this.inputData) {
              let payload = {
                from_date: from_date,
                to_date: to_date,
                timeframe: this.widget.meta.time_range
                  ? this.widget.meta.time_range
                  : "day",
                param_group_id: i.id,
                total: true,
                groupByDate: true,
              };
              let response = await axios.post(
                this.$store.state.api + "getParamGroupDailyDataBetweenDate",
                payload,
                { headers: { Authorization: "Bearer " + i.jwt } }
              );
              if (response.data.status === "success") {
                this.loading = false;
                let temp = {};
                temp["param"] = i.label;
                temp["data"] = response.data.data;
                this.tempDataFinale.push(temp);
              } else {
                this.loading = false;
                this.info = response.data.msg;
                this.showDismissibleAlert = true;
              }
            }

            this.createMultipleParamChart();
            this.loading = false;
          }
        } else {
          if (
            this.widget &&
            this.widget.meta &&
            this.widget.meta.data &&
            this.inputData
          ) {
            this.tempDataFinale = [];
            let payload = {
              params: [],
              from_timestamp: moment().startOf("day").unix(),
            };
            for (let i of this.inputData) {
              if (Array.isArray(i.id) && i.id.length > 1) {
                this.addIdealValueToGraph();
              } else {
                payload.params.push(i.id);
                let response = await axios.post(
                  this.$store.state.api + "getRawDataByParamsBetweenTimestamp",
                  payload,
                  {
                    headers: {
                      Authorization: "Bearer " + this.$store.state.jwt,
                    },
                  }
                );
                if (response.data.status === "success") {
                  this.loading = false;
                  this.tempDataFinale = response.data.data;
                  this.createSingleParamChart();
                } else {
                  this.loading = false;
                  this.info = response.data.msg;
                  this.showDismissibleAlert = true;
                }
              }
            }
            this.loading = false;
          }
        }
      } catch (err) {
        this.loading = false;
        this.info = err;
        this.showDismissibleAlert = true;
      }
      this.getDataFlag = false;
    },
    deleteWidget() {
      this.loading = true;
      axios
        .post(this.$store.state.api + "deleteWidget", this.widget, {
          headers: { Authorization: "Bearer " + this.$store.state.jwt },
        })
        .then((response) => {
          if (response.data.status === "success") {
            this.dialog = false;
            this.loading = false;
            this.$emit("update");
          }
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
    cancel() {
      this.showDialog = false;
    },
    confirm() {
      this.showDialog = false;
    },
  },
  watch: {
    timeframe() {
      this.createInputData();
    },
    widget() {
      this.createInputData();
    },
    inputData: {
      handler() {
        this.init();
      },
      deep: true,
    },
    graphType: function () {
      this.createMultipleParamChart();
    },
    idealValue: function (newIdealValue) {
      this.benchmarkLine.y = [newIdealValue ? newIdealValue : 0];
      this.createMultipleParamChart();
    },
  },
};
</script>

<style scoped></style>
